import React from 'react';
import { MemberFilter } from '~/components';
import FiltersGroup from './FiltersGroup';

function ContactFiltersGroup({ filters, onChange }) {
  return (
    <FiltersGroup label="Contact Filters" filters={[filters.contactOwners]}>
      <MemberFilter
        name="contactOwners"
        placeholder="Contact Owner"
        value={filters.contactOwners}
        onChange={({ target: { value } }) => onChange({ contactOwners: value })}
      />
    </FiltersGroup>
  );
}

export default ContactFiltersGroup;
